import React from "react";
import PageHeader from "../components/page-header";
import AboutUs from "../assets/images/travelcarma-about-us.png";
import Milestone from "../assets/images/travelcarma-milestones.png";
import Ebrochure from "../assets/images/travelcarma-ebrochure.jpg";
import EbrochurePDF from "../assets/resources/TravelCarma_ebrochure.pdf";
import { Link } from "react-router-dom";

const CompanyAboutUs = () => {
  return (
    <div className="page-inside">
      <PageHeader page="about-travelcarma" />

      <div className="container">
        <div className="row">
          <div className="col-lg-6 text-center">
            <img
              src={AboutUs}
              alt="About Us"
              title="About Us"
              className="w-100 mb-3"
              style={{ maxWidth: "450px" }}
            />
          </div>
          <div className="col-lg-6 text-justify">
            <p>
              <strong>TravelCarma</strong> is an AI-first enterprise{" "}
              <strong>travel technology</strong> brand owned by Avani Cimcon
              Technologies Ltd. With 20+ years of software delivery and deep
              travel domain experience, we help travel companies AI-enable
              existing workflows, manage and extend legacy systems, integrate
              and normalize supplier/API data, and build bespoke travel platforms when
              standard products cannot fit.
            </p>
            <p>
              Our product history is proof of capability. TravelCarma has built
              booking engines, B2B/B2C portals, supplier integrations,{" "}
              <strong>travel CRM</strong>, itinerary and quotation systems,
              back-office platforms, API aggregation layers, and enterprise
              travel infrastructure used by travel businesses worldwide.
            </p>
            <p>
              Today, we bring that product-building experience to AI-first
              travel technology engagements. We do not force travel companies to
              abandon working infrastructure. We work with existing systems,
              layer in practical AI at the right pace, and deploy dedicated
              travel technology engineering teams when deeper integration and
              execution are required.
            </p>
            <p>
              TravelCarma's technology has powered more than 200 portals in 50+
              countries, with multilingual and multicurrency capability across
              markets including Chinese, Vietnamese, Arabic, Spanish,
              Portuguese, French, and Persian. This global implementation
              experience helps us understand the operational complexity behind
              real travel businesses.
            </p>
          </div>
        </div>

        <div>
          <div
            className="shadow-sm p-4 mt-5 rounded"
            style={{ border: "solid 1px rgba(0,0,0,0.05)" }}
          >
            <h5 className="text-primary mb-3">
              TravelCarma works with established travel businesses across the
              travel ecosystem, including:
            </h5>
            <ul className="row">
              <li className="col-lg-6 mt-2">
                Online and offline travel agencies, OTAs, TMCs, B2B, B2C, and
                B2B2C businesses
              </li>
              <li className="col-lg-6 mt-2">
                Travel wholesalers, aggregators, consolidators, and distributors
              </li>
              <li className="col-lg-6 mt-2">
                Tour operators, excursion providers, and activity businesses
              </li>
              <li className="col-lg-6 mt-2">
                DMCs, tourism boards, and tourism associations
              </li>
              <li className="col-lg-6 mt-2">
                Accommodation groups, hotels, resorts, apartments, villas, and
                vacation rentals
              </li>
              <li className="col-lg-6 mt-2">
                Ground transportation providers, bus operators, car rental
                companies, limo and taxi operators
              </li>
            </ul>
          </div>
          <p className="mt-4">
            TravelCarma is a recognized <strong>travel technology</strong>{" "}
            brand with awards and industry recognition, including “One of the
            Top ten SaaS applications” from NASSCOM in 2011, selection among
            India’s “Top 100 IT innovators,” and participation at
            PhocusWright’s <strong>Travel Innovation Summit</strong>. These
            milestones reflect the depth of our travel technology architecture,
            product engineering, and implementation capability.
          </p>

          <p>
            Our mission today is to be the AI-first travel technology partner
            for companies that need to modernize carefully, operate reliably,
            integrate deeply, and build technology around their real business
            model without unnecessary disruption.
          </p>
        </div>

        <div className="text-center mt-5">
          <h2 className="mb-5">TravelCarma Milestones</h2>
          <img
            src={Milestone}
            alt="TravelCarma Milestones"
            title="TravelCarma Milestones"
            className="w-100 shadow-sm rounded p-5"
            style={{ border: "solid 1px rgba(0,0,0,0.05)" }}
          />
        </div>

        <div className="text-center mt-5">
          <h2 className="mb-5">E-brochure</h2>
          <div>
            <img
              src={Ebrochure}
              alt="TravelCarma eBroucher"
              title="TravelCarma eBroucher"
              className="shadow-sm rounded"
              style={{ border: "solid 1px rgba(0,0,0,0.05)", width: "50%" }}
            />
          </div>
          <Link
            to={EbrochurePDF}
            target="_blank"
            className="btn btn-primary mt-4"
          >
            Click to Download Brochure
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CompanyAboutUs;
